/* =========================================================================
   A/B-TEST "PreCart-Overlay vs. vollstaendiger Slide-Cart" — Phase 1
   -------------------------------------------------------------------------
   ZWECK (Phase 1 = A/A / Mess-Infrastruktur, KEINE sichtbare Aenderung):
     - liest den Bucket aus snippets/ab-precart-head.liquid (window.__AB_PRECART)
     - stempelt den Bucket als Cart-Attribut 'ab_precart' (DURCH CartJS) ->
       laeuft als "Additional details" in jede Shopify-Bestellung -> Geld-Wahrheit
     - feuert ein Exposure-Event (GA4 best-effort + optionaler First-Party-Beacon)
     - installiert einen FAIL-OPEN-Override auf dem EINZIGEN globalen Hook
       window.preCardOpenHandler (deckt alle 5 Add-to-Cart-Pfade ab), der in
       Phase 1 EXAKT Control-Verhalten beibehaelt (VARIANT_ACTIVE = false).

   IN PHASE 3 (Drawer fertig): VARIANT_ACTIVE = true setzen + variantBehavior()
   den neuen Slide-Cart oeffnen lassen. Das ist die einzige Zeile, die "scharf"
   schaltet — ein Ein-Zeilen-Flip in diesem statischen Asset.

   KILL-SWITCH: window.NILO_AB_PRECART_ENABLED = false  -> alles Control, nichts
   passiert (kein Stamping, kein Override). Ein-Zeilen-Edit, kein Redeploy noetig.

   SICHERHEIT: Add-to-Cart ist umsatzkritisch. Jeder Pfad ist try/catch-gekapselt
   und faellt im Fehlerfall auf das Original zurueck (fail OPEN). Der Override wird
   auf window.load installiert -> nach precard.js (defer) UND nach dem Swatch-
   Decorator (swatch_variants_handler.js:332-338), kapselt also den final
   komponierten Original-Handler (keine Rekursion) und heilt spaetes Re-Wrapping.
   ========================================================================= */
(function () {
  'use strict';

  // KILL-SWITCH: ENABLED=false -> Test komplett aus (Ein-Zeilen-Edit hier).
  // Zusaetzlich Laufzeit-Kill via Konsole: window.NILO_AB_PRECART_ENABLED=false
  var ENABLED = true;
  if (!ENABLED || window.NILO_AB_PRECART_ENABLED === false) return;

  var CFG = window.__AB_PRECART || { bucket: 'A', staff: false };

  // ----- Phase-Schalter ------------------------------------------------------
  // false  -> Bucket B verhaelt sich EXAKT wie A (A/A-Test, Phase 1)
  // true   -> variantBehavior() oeffnet den Slide-Cart fuer Bucket B (Phase 3)
  var VARIANT_ACTIVE = true;
  try { if (window.__AB_PRECART) window.__AB_PRECART.variantActive = VARIANT_ACTIVE; } catch (e) {}

  var BUCKET = (CFG.bucket === 'B') ? 'B' : 'A';
  var ATTR_KEY = 'ab_precart';

  // First-Party-Beacon (consent-/adblock-resistenter Zaehler fuer den Nenner).
  // URL kommt aus dem Theme-Setting settings.ab_beacon_url (via Head-Snippet).
  // Leer = deaktiviert. Events: 's' = Session, 'a' = Add-to-Cart, 'c' = Checkout-Start.
  var BEACON_URL = (CFG.beaconUrl || '');

  function fireBeacon(ev) {
    if (!BEACON_URL || CFG.staff) return;
    try {
      var u = BEACON_URL + (BEACON_URL.indexOf('?') < 0 ? '?' : '&') +
              'b=' + BUCKET + '&e=' + ev + '&t=' + Date.now();
      if (navigator.sendBeacon) navigator.sendBeacon(u);
      else fetch(u, { mode: 'no-cors', keepalive: true }).catch(function () {});
    } catch (e) { debug('beacon failed', e); }
  }

  function debug() {
    try {
      if (window.console && console.debug) {
        console.debug.apply(console, ['[ab-precart]'].concat([].slice.call(arguments)));
      }
    } catch (e) {}
  }

  // ----- Bucket als Cart-Attribut stempeln (Geld-Wahrheit) -------------------
  // Bevorzugt DURCH CartJS (vermeidet Konflikt mit der bestehenden Cart-Schicht),
  // sonst native /cart/update.js (aendert KEINE Line-Items). Best-effort.
  var _lastStamped = null;
  function stampAttribute() {
    if (CFG.staff) return; // Staff nicht in die Auswertung schreiben
    if (_lastStamped === BUCKET) return;
    // 1) CartJS
    try {
      if (window.CartJS && typeof window.CartJS.setAttributes === 'function') {
        var cur = (window.CartJS.cart && window.CartJS.cart.attributes) || {};
        if (cur[ATTR_KEY] === BUCKET) { _lastStamped = BUCKET; return; }
        var a = {}; a[ATTR_KEY] = BUCKET;
        window.CartJS.setAttributes(a);
        _lastStamped = BUCKET;
        debug('stamped via CartJS ->', BUCKET);
        return;
      }
    } catch (e) { debug('CartJS stamp failed', e); }
    // 2) Fallback: native Ajax-API
    try {
      var body = {}; body[ATTR_KEY] = BUCKET;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: body })
      }).then(function () {
        _lastStamped = BUCKET;
        debug('stamped via /cart/update.js ->', BUCKET);
      }).catch(function (e) { debug('update.js stamp failed', e); });
    } catch (e) { debug('stamp fallback failed', e); }
  }

  // ----- Exposure tracken (GA4 best-effort + optionaler Beacon) --------------
  var _exposed = false;
  function trackExposure() {
    if (_exposed || CFG.staff) return;
    _exposed = true;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'ab_exposure', ab_precart: BUCKET });
      if (typeof window.gtag === 'function') {
        window.gtag('set', 'user_properties', { ab_precart: BUCKET });
        window.gtag('event', 'ab_exposure', { ab_precart: BUCKET });
      }
    } catch (e) { debug('ga4 exposure failed', e); }
    // Session-Beacon: einmal pro Session (nicht pro Pageview) -> sauberer Nenner
    try {
      if (!sessionStorage.getItem('ab_beacon_s')) {
        sessionStorage.setItem('ab_beacon_s', '1');
        fireBeacon('s');
      }
    } catch (e) { fireBeacon('s'); }
  }

  // ----- Drawer-Assets nur fuer Bucket B lazy laden (A bleibt unangetastet) ---
  var _assetsLoaded = false;
  function loadDrawerAssets() {
    if (_assetsLoaded) return;
    _assetsLoaded = true;
    try {
      var a = (CFG.assets || {});
      if (a.css) {
        var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = a.css;
        document.head.appendChild(l);
      }
      if (a.js) {
        var s = document.createElement('script'); s.src = a.js; s.defer = true;
        document.head.appendChild(s);
      }
    } catch (e) { debug('drawer asset load failed', e); }
  }

  // ----- B-Verhalten: vollstaendigen Slide-Cart oeffnen ----------------------
  function variantBehavior(realHandler, ctx, args) {
    if (typeof window.openCompleteDrawer === 'function') { window.openCompleteDrawer(); return; }
    // Drawer-JS noch nicht bereit -> fail-safe: Original-PreCart zeigen
    // (Kunde bekommt IMMER eine funktionierende Bestaetigung, nie toter Klick)
    debug('drawer not ready -> fail-safe to control');
    if (typeof realHandler === 'function') return realHandler.apply(ctx, args);
  }

  // ----- Override des einzigen globalen Hooks (fail-OPEN, selbstheilend) ------
  function installOverride() {
    var cur = window.preCardOpenHandler;
    if (cur && cur.__abControlled) return; // bereits unser Wrapper -> nichts tun
    var real = cur; // final komponierter Original-Handler (precard + swatch-decorator)

    function wrapper() {
      // 1) Messung laeuft IMMER (auch im Control-Pfad / Phase-1-B)
      try { stampAttribute(); trackExposure(); } catch (e) { debug('measure error', e); }
      // 2) Variantenverhalten nur wenn scharf geschaltet UND Bucket B
      if (VARIANT_ACTIVE && BUCKET === 'B') {
        try { return variantBehavior(real, this, arguments); }
        catch (e) { debug('variant error -> fail open', e); }
      }
      // 3) Control-Pfad: Original in eigenem try/catch (Original kann selbst werfen)
      try { if (typeof real === 'function') return real.apply(this, arguments); }
      catch (e) { debug('original handler threw (fail open)', e); }
    }
    wrapper.__abControlled = true;
    wrapper.__real = real;
    try { window.preCardOpenHandler = wrapper; debug('override installed, bucket', BUCKET); }
    catch (e) { debug('override install failed', e); }
  }

  function onReady(fn) {
    if (document.readyState === 'complete') fn();
    else window.addEventListener('load', fn);
  }

  onReady(function () {
    installOverride();
    stampAttribute();   // deckt bestehenden Warenkorb / Direkteinstieg ab
    trackExposure();
    // Re-Stamp nach jeder CartJS-Cart-Aenderung (jeder Add) — idempotent
    try {
      if (window.jQuery) {
        window.jQuery(document).on('cart.requestComplete', function () {
          _lastStamped = null; stampAttribute();
        });
      }
    } catch (e) {}
    // Sicherheitsnetz gegen spaetes Re-Wrapping des globalen Hooks
    setTimeout(installOverride, 1500);
  });

  // Bucket B: Drawer-Assets sofort vorladen (A laedt sie NIE)
  if (BUCKET === 'B' && VARIANT_ACTIVE) loadDrawerAssets();

  // ----- Beacon-Events: Add-to-Cart + Checkout-Start (beide Buckets) ---------
  // ATC universell: window.fetch abfangen und /cart/add.js zaehlen (deckt alle
  // Add-Pfade ab — Theme, Konfigurator, Drawer-Upsells). Defensiv: gibt IMMER
  // die Original-Promise zurueck, faengt nie ab, bricht nie.
  if (BEACON_URL) {
    try {
      var _origFetch = window.fetch;
      if (_origFetch && !_origFetch.__abPatched) {
        var patched = function (input) {
          var p = _origFetch.apply(this, arguments);
          try {
            var url = (typeof input === 'string') ? input : (input && input.url) || '';
            if (url.indexOf('/cart/add') > -1) {
              p.then(function (r) { if (r && r.ok) fireBeacon('a'); }).catch(function () {});
            }
          } catch (e) {}
          return p;
        };
        patched.__abPatched = true;
        window.fetch = patched;
      }
    } catch (e) { debug('fetch patch failed', e); }

    // Checkout-Start: jeder Klick auf einen Checkout-Button/-Link (A: Cart-Seite,
    // B: Drawer-Button, sowie direkte /checkout-Links)
    document.addEventListener('click', function (e) {
      try {
        if (e.target.closest('[name="checkout"], #checkout, .cart__checkout-button, [data-ab-checkout], a[href*="/checkout"]')) {
          fireBeacon('c');
        }
      } catch (e2) {}
    }, true);
  }

  // Diagnostik fuer QA: in der Konsole __abPrecartInfo() aufrufen
  window.__abPrecartInfo = function () {
    return {
      bucket: BUCKET,
      staff: CFG.staff,
      forced: CFG.forced,
      variantActive: VARIANT_ACTIVE,
      overrideInstalled: !!(window.preCardOpenHandler && window.preCardOpenHandler.__abControlled),
      lastStamped: _lastStamped,
      exposed: _exposed
    };
  };
  debug('init', { bucket: BUCKET, staff: CFG.staff, variantActive: VARIANT_ACTIVE });
})();
